import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CxModalInstance } from 'app/shared/cx-modal/cx-modal-instance.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'warning-remove-products-modal',
  templateUrl: './warning-remove-products-modal.component.html',
  styleUrls: ['./warning-remove-products-modal.component.scss'],
  providers: [CxModalInstance],
})
export class WarningRemoveAdditionalProductsModalComponent {
  @Input() rtl = false;
  @Output() close = new EventEmitter();
  @Input() accept = new EventEmitter();
  @Input() cancel = new EventEmitter();

  modalOpen$ = new BehaviorSubject(false);

  closeModal() {
    this.close.emit();
  }

  acceptReset() {
    this.accept.emit();
  }

  cancelReset() {
    this.cancel.emit();
  }
}
